(function () {
  var SECTION_SELECTOR = '.oddit-section-video-highlight';

  function initSection(section) {
    if (!section) return;

    var player = section.querySelector('[data-video-player]');
    if (!player) return;

    var trigger = player.querySelector('[data-video-trigger]');
    var template = player.querySelector('[data-video-template]');
    if (!trigger || !template) return;
    if (trigger.dataset.odditBound === '1') return;
    trigger.dataset.odditBound = '1';

    trigger.addEventListener('click', function () {
      var fragment = template.content.cloneNode(true);
      var video = fragment.querySelector('video');

      trigger.replaceWith(fragment);
      template.remove();

      if (video) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () { /* user can hit native controls */ });
        }
      }
    });
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
